import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { InputLabel, Select, MenuItem } from "@material-ui/core";
import __ from "lodash";

const FormSelect = (props) => {

  const {id, label, readOnly, disabled, renderValue, options, onChange, style, value, fullWidth} = props;
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  const className = classNames.join(" ");

  return (
    <div>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative"}} >{label}</InputLabel>
        :<></>
      }
      <Select
        id={id}
        style={style}
        className={className}
        readOnly={readOnly}
        disabled={disabled}
        fullWidth={fullWidth}
        onChange={onChange}
        value={value}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          }
        }}
        renderValue={(code) => {
          let value = code;
          if (typeof renderValue === "function"){
            value = renderValue(code, options);
          } else {
            const option = __.find(options, {code});
            if (option) {
              value = option.value;
            }
          }
          return value;
        }}
      >
        {(options) ?
          options.map((option) => {
            return (
              <MenuItem key={option.code} value={option.code}>{option.value}</MenuItem>);
          }) :
          null
        }
      </Select>
    </div>
  );
}

export default FormSelect;